import {
  createTarget,
  saveTarget,
  activateTarget,
  uploadNPowerSegments,
  sendNPowerDownstream,
  sendComscoreDownstream,
  uploadComscoreSegments,
  overwritePIDFiles,
  getUploadTargetData,
  fetchSingleTarget,
  moveStagedFileToUpload,
  getTargetResources,
  duplicateTarget,
  getComscoreDemos
} from '@/api'
import router from '@/router'
import { tableMap } from '@/router/tableMap.js'
import Toast from '@/components/common/toasts/'
import RecurringToast from '@/components/common/toasts/RecurringToast'
import {
  ADD_TARGET_TO_TARGET_LIST,
  REFRESH_TABLE,
  UPDATE_TARGET,
  REPLACE_TARGET,
  FORECAST_TARGET_TO_TARGET_LIST
} from '@/views/audienceHub/store/actions'
import {
  LAS_TYPES,
  TARGET_ACTIONS,
  TARGET_TYPE,
  TARGET_TYPES_INTEGERS,
  ACTIVATION_STATUS,
  DESTINATIONS
} from '@/appLogic/targets/Constants'
import { SET_TARGET } from '@/appLogic/workbench/common/store/actions'
import {createATTCreation} from '@/appLogic/targets/createTarget/ATTCreation'
import UploadTargetFile from '@/appLogic/targets/uploadingTarget/UploadTargetFile'
import {correctToUTCTime} from '@/common/U_D'
import {SET_SHOW_APPEND_MODAL} from '@/appLogic/targets/currentTarget/store/actions'

const module = 'CREATE_TARGET_'

export const SET_SHOW_MODAL_STEPPER = module + 'SET_SHOW_MODAL_STEPPER'
export const SET_UPDATING_TARGET = module + 'SET_UPDATING_TARGET'
export const SET_STEPPER_DATA_SOURCE = module + 'SET_STEPPER_DATA_SOURCE'
export const APPEND_PID = module + 'APPEND_PID'
export const CREATE_TARGET = module + 'CREATE_TARGET'
export const IS_DIGITAL = module + 'IS_DIGITAL'
export const CREATE_TARGET_NO_ACTUALS = module + 'CREATE_TARGET_NO_ACTUALS'
export const UPLOAD_TARGET_FILE = module + 'UPLOAD_TARGET_FILE'
export const OVERWRITE_PID = module + 'OVERWRITE_PID'
export const UPLOAD_NPOWER_SEGMENTS = module + 'UPLOAD_NPOWER_SEGMENTS'
export const SEND_NPOWER_DOWNSTREAM = module + 'SEND_NPOWER_DOWNSTREAM'
export const SEND_COMSCORE_DOWNSTREAM = module + 'SEND_COMSCORE_DOWNSTREAM'
export const SET_LOADING = module + 'SET_LOADING'
export const SET_UPLOAD_MODAL_OPTIONS = module + 'SET_UPLOAD_MODAL_OPTIONS'
export const GET_SEGMENT_UPLOAD_DATA = module + 'GET_SEGMENT_UPLOAD_DATA'
export const UPLOAD_MODAL_SET_APPEND_TYPE = module + 'UPLOAD_MODAL_SET_APPEND_TYPE'
export const SUBMIT_ATT_TARGET = module + 'SUBMIT_ATT_TARGET'
export const CREATE_TARGET_PURE = module + 'CREATE_TARGET_PURE'
export const ACTIVATE_PID_NPOWER = module + 'ACTIVATE_PID_NPOWER'
export const MOVE_STAGED_FILE_TO_UPLOAD = module + 'MOVE_STAGED_FILE_TO_UPLOAD'
export const SUBMITTING_PID_NPOWER = module + 'SUBMITTING_PID_NPOWER'
export const RESET_THE_LAS_MODAL = module + 'RESET_THE_LAS_MODAL'
export const SET_INITIAL_TARGET_ACTION = module + 'SET_INITIAL_TARGET_ACTION'
export const SET_INITIAL_TARGET = module + 'SET_INITIAL_TARGET'
export const DUPLICATE_TARGET = module + 'DUPLICATE_TARGET'
export const SET_INTENTS = module + 'SET_INTENTS'
export const GET_DEMOS = module + 'GET_DEMOS'
export const UPDATE_TARGET_STATUS = module + 'UPDATE_TARGET_STATUS'

const actions = {
  [APPEND_PID]: (context) => {
    context.commit(APPEND_PID)
  },
  [SET_SHOW_MODAL_STEPPER]: (context, payload = {targetAction: TARGET_ACTIONS.NEW}) => {
    context.commit(SET_INITIAL_TARGET_ACTION, payload.targetAction)
    context.commit(SET_SHOW_MODAL_STEPPER, payload)
  },
  [SET_STEPPER_DATA_SOURCE]: (context, {option, target_id, targetAction}) => {
    let target
    const nielsenDatasources = context.rootGetters.getNielsenDatasources
    const fetchAudience = new Promise((resolve, reject) => {
      if ((option === nielsenDatasources.FILE || option === LAS_TYPES.XANDR || option === nielsenDatasources.AMRLD || option === nielsenDatasources.NCS || option === nielsenDatasources.MRI || option === nielsenDatasources.AUDIENCE_DISCOVERY) && target_id) {
        context.commit(SET_LOADING, true)
        fetchSingleTarget({target_id}).then(resp => {
          target = resp.data
          target.created = new Date(target.created)
          let isAnUploadedFileOrXandrNative = (option === nielsenDatasources.FILE || option === LAS_TYPES.XANDR) && target.am_data
          if (isAnUploadedFileOrXandrNative) {  // have to set the timeZones from New York to UTC
            target.am_data.flightStartDate = target.am_data.flightStartDate ? correctToUTCTime(target.am_data.flightStartDate) : target.am_data.flightStartDate
            target.am_data.flightEndDate = target.am_data.flightEndDate ? correctToUTCTime(target.am_data.flightEndDate) : target.am_data.flightEndDate
            target.am_data.AEFlightEndDate = target.am_data.AEFlightEndDate ? correctToUTCTime(target.am_data.AEFlightEndDate) : null
            if (target.am_data.submitted_timestamp) {
              // convertLocalStringToLocal(target.am_data.submitted_timestamp)
              target.am_data.submitted_timestamp = correctToUTCTime(new Date(target.am_data.submitted_timestamp))
            }
          }
          if (targetAction === TARGET_ACTIONS.DUPLICATE) {
            if (target.destinations && target.destinations.includes(DESTINATIONS.SYMPHONY) && target.am_data) {
              target.am_data.flightStartDate = null
              target.am_data.flightEndDate = null
              target.am_data.AEFlightStartDate = null
              target.am_data.AEFlightEndDate = null
            }
            context.dispatch(SET_INITIAL_TARGET, target)
            context.commit(SET_SHOW_MODAL_STEPPER, { step: 3, target: target })
          } else if (targetAction === TARGET_ACTIONS.UPDATE || targetAction === TARGET_ACTIONS.UPDATE_CAMPAIGN || targetAction === TARGET_ACTIONS.SEGMENT_INFO) {
            context.dispatch(SET_UPDATING_TARGET, target)
            context.commit(SET_SHOW_MODAL_STEPPER, { step: 2, target: target })
            context.commit(SET_STEPPER_DATA_SOURCE, option)
          }
          context.commit(SET_INITIAL_TARGET_ACTION, targetAction)
          context.commit(SET_LOADING, false)
          resolve()
        }).catch(err => {
          console.error(err)
          context.commit(SET_LOADING, false)
          reject(err)
        })
      } else {
        if (option === null) {
          context.commit(SET_STEPPER_DATA_SOURCE, option)
        }
        resolve()
      }
    })

    fetchAudience.then(() => {
      if (targetAction === TARGET_ACTIONS.UPDATE_CAMPAIGN) {
        context.commit(IS_DIGITAL, true)
      }
    })
  },
  [SET_UPDATING_TARGET]: (context, target) => {
    context.commit(SET_UPDATING_TARGET, target)
  },
  [SET_INITIAL_TARGET]: (context, target) => {
    context.commit(SET_INITIAL_TARGET, target)
  },
  [SET_INITIAL_TARGET_ACTION]: (context, targetAction) => {
    context.commit(SET_INITIAL_TARGET_ACTION, targetAction)
  },
  [GET_SEGMENT_UPLOAD_DATA] (context, target) {
    context.commit(SET_LOADING, true)
    return getUploadTargetData({target_type: target.target, id: target.id})
      .then(function (response) {
        context.commit(SET_LOADING, false)
        return response.data
      })
      .catch(function (e) {
        console.error(e)
        context.commit(SET_LOADING, false)
        return null
      })
  },
  [ACTIVATE_PID_NPOWER] (context, {target, file}) {
    return context.dispatch(CREATE_TARGET_PURE, target).then(createdTarget => {
      context.commit(SET_LOADING, true)
      if (file) {
        return context.dispatch(UPLOAD_TARGET_FILE, {
          target: createdTarget,
          file,
          options: {staged: true}
        }).then(res => {
          context.commit(SET_LOADING, false)
          return createdTarget
        })
      } else {
        context.commit(SET_LOADING, false)
        return createdTarget
      }
    })
  },
  [SET_UPLOAD_MODAL_OPTIONS]: (context, options) => {
    // type: 1 is for create new and 2 is for appending
    // appending_option: 1 is for NPOwer,  2 is for PID
    context.commit(SET_UPLOAD_MODAL_OPTIONS, options)
    if (options) {
      const nielsenDatasources = context.rootGetters.getNielsenDatasources
      context.commit(SET_STEPPER_DATA_SOURCE, nielsenDatasources.FILE)
      context.commit(SET_SHOW_MODAL_STEPPER, options.target)
    }
  },
  [OVERWRITE_PID]: (context, {targetId, overwrites}) => {
    context.commit(SET_LOADING, true)
    return overwritePIDFiles({target_id: targetId, overriddens: overwrites}).then(res => {
      context.commit(SET_LOADING, false)
      Toast.success({title: 'Appending File', message: 'File successfully Appended.'})
      return null
    })
  },
  [UPLOAD_TARGET_FILE] (context, {target, file, options, isAppend}) {
    let uploader = new UploadTargetFile(context, file, options, target, isAppend)
    return uploader.run()
  },
  [UPLOAD_NPOWER_SEGMENTS]: (context, payload) => {
    context.commit(SET_LOADING, true)
    let uploader
    if (payload.segmentData.DataProvider === 'NPOWER') {
      uploader = uploadNPowerSegments(payload)
    } else {
      uploader = uploadComscoreSegments(payload)
    }
    return uploader.then(res => {
      context.commit(SET_LOADING, false)
      // Remove this once we fix the segment data being overwritten
      context.dispatch(SET_SHOW_APPEND_MODAL, {showModal: false})
      const target = res.data
      console.log(`successfully uploaded ${payload.segmentData.DataProvider} segments! updated target:`, target)
      Toast.success({
        title: 'Audience Segments Uploaded',
        message: 'The audience segments have been successfully added to your target!',
        timeout: 10000
      })
      context.commit(UPDATE_TARGET, {id: payload.target_id, updatedTarget: target})
      return res.data
    }).catch((e) => {
      console.error(e)
      Toast.error({
        title: 'Error Uploading Audience Segments',
        message: 'There was an error adding the audience segments to your target.',
        timeout: 10000
      })
      context.commit(SET_LOADING, false)
    })
  },
  [SEND_NPOWER_DOWNSTREAM]: (context, payload) => {
    context.commit(SET_LOADING, true)
    return sendNPowerDownstream(payload).then(res => {
      context.commit(SET_LOADING, false)
      const target = res.data
      console.log(`successfully sent segments downstream! updated target:`, target)
      Toast.success({
        title: 'Audience Segments Sent Downstream',
        message: 'The audience segments have been successfully sent downstream!',
        timeout: 10000
      })
      context.commit(UPDATE_TARGET, {id: payload.target_id, updatedTarget: target})
      return res.data
    }).catch((e) => {
      const message = (e.response || {}).data
      console.error(message || e)
      Toast.error({
        title: 'Error Sending Audience Segments Downstream',
        message: message || 'There was an error sending the audience segments downstream.',
        timeout: 10000
      })
      context.commit(SET_LOADING, false)
    })
  },
  [SEND_COMSCORE_DOWNSTREAM]: (context, payload) => {
    context.commit(SET_LOADING, true)
    return sendComscoreDownstream(payload).then(res => {
      context.commit(SET_LOADING, false)
      const target = res.data
      console.log(`successfully sent segments downstream! updated target:`, target)
      Toast.success({
        title: 'Audience Segments Sent Downstream',
        message: 'The audience segments have been successfully sent downstream!',
        timeout: 10000
      })
      context.commit(UPDATE_TARGET, {id: payload.target_id, updatedTarget: target})
      return res.data
    }).catch((e) => {
      const message = (e.response || {}).data
      console.error(message || e)
      Toast.error({
        title: 'Error Sending Audience Segments Downstream',
        message: message || 'There was an error sending the audience segments downstream.',
        timeout: 10000
      })
      context.commit(SET_LOADING, false)
    })
  },
  [MOVE_STAGED_FILE_TO_UPLOAD]: (context, {target}) => {
    return moveStagedFileToUpload({target}).then(res => {
      Toast.success({
        title: 'Staged upload file being processed',
        message: 'The staged file is now being processed',
        timeout: 10000
      })
    }).catch(e => {
      Toast.error({
        title: 'Error Moving staged file to Upload location',
        message: 'There was something wrong with moving the staged file to be processed',
        timeout: 10000
      })
    })
  },
  [IS_DIGITAL] (context, value) {
    context.commit(IS_DIGITAL, value)
  },
  [CREATE_TARGET] (context, target) {
    context.commit(SET_LOADING, true)
    return createTarget(target)
    .then(function (response) {
      context.commit(SET_LOADING, false)
      // eslint-disable-next-line no-undef
      adobeAnalytics.createTarget({
        username: target.username,
        target: {
          name: target.display_name,
          type: target.target,
          id: response.data.id
        }
      })
      target = response.data
      if (target.target === TARGET_TYPE.SD || target.target === TARGET_TYPE.AD) {
        router.push({ name: tableMap[target.target], params: { id: target.id } })
      }
      return target
    }).catch(() => {
      context.commit(SET_LOADING, false)
    })
  },
  [CREATE_TARGET_NO_ACTUALS] (context, target) {
    context.commit(SET_LOADING, true)
    context.dispatch(REFRESH_TABLE, false)
    return activateTarget(target)
      .then(function (response) {
        context.commit(SET_LOADING, false)
        const createdTarget = response.data
        context.dispatch(ADD_TARGET_TO_TARGET_LIST, createdTarget)
      }).catch(() => {
        context.commit(SET_LOADING, false)
      })
  },
  [CREATE_TARGET_PURE] (context, target) {
    context.commit(SET_LOADING, true)
    context.dispatch(REFRESH_TABLE, false)
    return createTarget(target)
    .then(function (response) {
      context.commit(SET_LOADING, false)
      // eslint-disable-next-line no-undef
      adobeAnalytics.createTarget({
        username: target.username,
        target: {
          name: target.display_name,
          type: target.target,
          id: response.data.id
        }
      })
      target = response.data
      context.dispatch(ADD_TARGET_TO_TARGET_LIST, target)
      return target
    }).catch(() => {
      context.commit(SET_LOADING, false)
    })
  },
  [UPDATE_TARGET_STATUS] (context, {targetId, activation_status}) {
    return saveTarget({'id': targetId, 'activation_status': activation_status})
  },
  [SUBMITTING_PID_NPOWER] (context, {target, file, onComplete}) {
    onComplete = onComplete || (() => {})
    context.commit(SET_LOADING, true)
    const targetExists = target.id
    context.dispatch(REFRESH_TABLE, false)
    return createTarget(target).then(res => {
      target = res.data
      if (!targetExists) {
        context.dispatch(ADD_TARGET_TO_TARGET_LIST, target)
      }
      if (file) {
        return context.dispatch(UPLOAD_TARGET_FILE, {target, file}).then(res => {
          if (res.Error) {
            return context.dispatch(UPDATE_TARGET_STATUS, {targetId: target.id, activation_status: ACTIVATION_STATUS.FAILED}).then(r => {
              context.commit(SET_LOADING, false)
              context.dispatch(REFRESH_TABLE, true)
              onComplete(target)
            })
          }
          if (!res.Error) {
            context.commit(SET_LOADING, false)
            context.dispatch(FORECAST_TARGET_TO_TARGET_LIST, target.id)
            onComplete(target, res)
          }
        })
      } else {
        return context.dispatch(MOVE_STAGED_FILE_TO_UPLOAD, {target}).then(res => {
          const getNpowerResource = function () {
            const rt = new RecurringToast({
              type: 'info',
              title: 'Waiting for Segement Info',
              message: 'Currently retrieving Segment Information',
              interval: 5000
            })
            rt.start()
            const recursiveFunc = () => {
              getTargetResources(target.id).then(resp => {
                if (resp.data.length === 0) {
                  setTimeout(recursiveFunc, 5000)
                } else {
                  rt.stop()
                  context.commit(SET_LOADING, false)
                  context.dispatch(FORECAST_TARGET_TO_TARGET_LIST, target.id)
                  onComplete(target, {target: target, irisResponse: resp.data[0].data})
                }
              })
            }
            recursiveFunc()
          }
          if (target.target_type === TARGET_TYPES_INTEGERS.NPOWER || target.target_type === TARGET_TYPES_INTEGERS.COMSCORE) {
            getNpowerResource()
          } else {
            context.commit(SET_LOADING, false)
            context.dispatch(FORECAST_TARGET_TO_TARGET_LIST, target.id)
            onComplete(target)
          }
        })
      }
    })
  },
  [DUPLICATE_TARGET] (context, {target, duplicate_id}) {
    context.commit(SET_LOADING, true)
    return duplicateTarget({target, duplicate_id})
    .then(function (response) {
      // eslint-disable-next-line no-undef
      adobeAnalytics.createTarget({
        username: target.username,
        target: {
          name: target.display_name,
          type: target.target,
          id: response.data.id
        }
      })
      context.commit(CREATE_TARGET, response.data)
      context.commit(SET_LOADING, false)
      return response.data
    })
    .catch(function (reason) {
      context.commit(SET_LOADING, false)
    })
  },
  [SUBMIT_ATT_TARGET] (context, {target, isNew, activate, submitted, submittingOrHasSubmittedFile}) {
    context.commit(SET_LOADING, true)
    context.dispatch(REFRESH_TABLE, false)
    const createAction = createATTCreation({target, isNew, activate, submitted, submittingOrHasSubmittedFile},
      {
        afterCreate: (createdTarget) => context.dispatch(ADD_TARGET_TO_TARGET_LIST, createdTarget),
        afterSave: (createdTarget) => context.dispatch(REPLACE_TARGET, createdTarget)
      })
    return createAction.run().then(createdTraget => {
      context.commit(SET_LOADING, false)
    }).catch(ex => {
      context.commit(SET_LOADING, false)
    })
  },
  [UPLOAD_MODAL_SET_APPEND_TYPE] (context, appendType) {
    context.commit(UPLOAD_MODAL_SET_APPEND_TYPE, appendType)
  },
  [RESET_THE_LAS_MODAL] (context) {
    context.dispatch(SET_STEPPER_DATA_SOURCE, {option: null, targetAction: null})
    context.dispatch(UPLOAD_MODAL_SET_APPEND_TYPE, null)
  },
  [SET_INTENTS] (context, value) {
    context.commit(SET_INTENTS, value)
  },
  [GET_DEMOS] (context) {
    getComscoreDemos().then(response => {
      context.commit(GET_DEMOS, response)
    })
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/createTarget/store/actions.js